module.exports = __webpack_public_path__ + "static/little-big-8343f1195b858eaf5769d2ec790a3416.jpg";